import { render, staticRenderFns } from "./SignupFormAccountants.vue?vue&type=template&id=15fd064e&scoped=true&"
import script from "./SignupFormAccountants.vue?vue&type=script&lang=js&"
export * from "./SignupFormAccountants.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormAccountants.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupFormAccountants.vue?vue&type=style&index=1&id=15fd064e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd064e",
  null
  
)

export default component.exports